/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect } from "react";
import { Route, Navigate, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import ReactGA from "react-ga4";
import Home from "./pages/HomePage";
import Layout from "./components/Layout";
import PayableCityDetails from "./pages/PayableCityDetails";
import ContributionCycleDetails from "./pages/ContributionCycle";
import DepositBankDetails from "./pages/DepositBankDetails";
import BankDetails from "./pages/BankDetails";
// import ReceiptTypes from './pages/ReceiptTypes';
import MessageTicker from "./pages/MessageTicker";
import Login from "./pages/Login";
import { ROUTES } from "./components/Routes";
import OTPAuthentication from "./pages/OTPAuthentication";
// import { useSelector } from "react-redux";
import ReceiptTypes from "./pages/ReceiptTypes";
import CancelledReceiptReport from "./pages/Reports/CancelledReciept/CancelledReciept";
import TotalReceiptReport from "./pages/Reports/TotalReceiptReport/TotalReceiptReport";
import TotalCancelledReceiptReport from "./pages/Reports/TotalCancelledReceiptReports/TotalCancelledReceiptReport";
import TotalCollectionReport from "./pages/Reports/TotalCollection/TotalCollectionReport";
import ContributionComparisonReport from "./pages/Reports/ContributionComparison/ContributionComparisonReport";
import ChequesReportsSearch from "./pages/Reports/ChequesReports/ChequesReportsSearch";
import MemberSearch from "./pages/Member/MemberSearch/MemberSearch";
import MemberContributionView from "./pages/Member/MemberContributionView";
import ContributionDetails from "./pages/Member/ContributionDeatils";
import MemberContributionViewUpdate from "./pages/Member/MemberContributionViewUpdate";
import MemberContributionUpdate from "./pages/Member/MemberContributionUpdate";
import PendingOnlineContribution from "./pages/PendingOnlineContribution/PendingOnlineContribution";
// import CaptureOnlineContribution from "./pages/CaptureOnlineContribution";
import DrawnBankDetails from "./pages/DrawnBankDetails";
import DownloadReports from "./pages/Reports/DownloadReports";
// import ReportCaptureOnlineContribution from "./pages/ReportCaptureOnlineContribution";
import Forgot from "./pages/ForgetPassword/Forget";
import ChangePassword from "./pages/ForgetPassword/ChangePassword";
import NewCaptureOnlineContribution from "./pages/CaptureOnlineContribution/NewCaptureOnlineContribution";
import CaptureOnlineContributionReport from "./pages/Reports/CaptureOnlineContributionReport/CaptureOnlineContributionReport";
import SearchOnlineContributionPrintForm from "./pages/Reports/SearchOnlineContributionPrintForm/SearchOnlineContributonPrintForm";
import MemberDetails from "./pages/Member/MemberSearch/MemberView";
import ChapterLevelContributionCycleDetails from "./pages/ChapterLevelContributionCycle";
import BankDepositDetails from "./pages/BankDepositDetails";
import TotalCollectionChapterReport from "./pages/Reports/TotalCollectionChapterReport/TotalCollectionChapterReport";
import CashReport from "./pages/Reports/CashReports/CashReports";
import Form10BESearch from "./pages/Form10BESearch/Form10BESearch";
import TaxUtilityReport from "./pages/Reports/TaxUtilityReport/TaxUtilityReport";
import BulkReceiptDownload from "./pages/BulkReceiptDownload/BulkReceiptDownload";

function AppRouter() {
  function PrivateRoute() {
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

    // If authorized, return an outlet that will render child elements
    // If not, return element that will navigate to login page
    return isAuthenticated ? <Layout /> : <Navigate to={ROUTES.LOGIN_PAGE} />;
  }
  useEffect(() => {
    ReactGA.initialize("G-1T2W8QFWPV");
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  return (
    <Routes>
      <Route path={ROUTES.LOGIN_PAGE} element={<Login />} />
      <Route
        path={ROUTES.OTP_AUTHENTICATION_PAGE}
        element={<OTPAuthentication />}
      />
      <Route path={ROUTES.FORGET_PASSWORD} element={<Forgot />} />
      <Route
        path={`${ROUTES.CHANGE_PASSWORD}/:memberId/:authToken`}
        element={<ChangePassword />}
      />
      <Route exact path="/" element={<PrivateRoute />}>
        <Route exact path={ROUTES.DASHBOARD} element={<Home />} />
        <Route exact path={ROUTES.MESSAGE_TICKER} element={<MessageTicker />} />
        <Route
          exact
          path={ROUTES.PAYABLE_CITY}
          element={<PayableCityDetails />}
        />
        <Route
          exact
          path={ROUTES.CONTRIBUTION_CYCLE}
          element={<ContributionCycleDetails />}
        />
        <Route
          exact
          path={ROUTES.CHAPTER_LEVEL_CONTRIBUTION_CYCLE}
          element={<ChapterLevelContributionCycleDetails />}
        />
        <Route
          exact
          path={ROUTES.BANK_DEPOSIT_DETAILS}
          element={<BankDepositDetails />}
        />
        <Route exact path={ROUTES.BANK_DETAILS} element={<BankDetails />} />
        <Route
          exact
          path={ROUTES.BRANCH_DETAILS}
          element={<DepositBankDetails />}
        />
        <Route
          exact
          path={ROUTES.DRAWN_BANK_DETAILS}
          element={<DrawnBankDetails />}
        />
        <Route exact path={ROUTES.RECEIPT_TYPES} element={<ReceiptTypes />} />
        <Route
          exact
          path={ROUTES.CANCELLED_RECEIPT_REPORT}
          element={<CancelledReceiptReport />}
        />
        <Route
          exact
          path={ROUTES.TOTAL_RECEIPT_REPORT}
          element={<TotalReceiptReport />}
        />
        <Route
          exact
          path={ROUTES.TOTAL_CANCELLED_RECEIPT_REPORT}
          element={<TotalCancelledReceiptReport />}
        />
        <Route
          exact
          path={ROUTES.TOTAL_COLLECTION_REPORT}
          element={<TotalCollectionReport />}
        />
        <Route
          exact
          path={ROUTES.TOTAL_COLLECTION_CHAPTER_REPORT}
          element={<TotalCollectionChapterReport />}
        />
        <Route
          exact
          path={ROUTES.CONTRIBUTION_COMPARISON_REPORT}
          element={<ContributionComparisonReport />}
        />
        {/* <Route exact path="/master-setup/setup-deatils/receipt-types" element={<ReceiptTypes/>}/> */}
        <Route
          exact
          path={ROUTES.CHEQUES_DETAILS_REPORT}
          element={<ChequesReportsSearch />}
        />
        <Route
          exact
          path={ROUTES.TAX_UTILITY_REPORT}
          element={<TaxUtilityReport />}
        />
        <Route
          exact
          path={ROUTES.DOWNLOAD_REPORTS}
          element={<DownloadReports />}
        />
        <Route exact path={ROUTES.MEMBER_SEARCH} element={<MemberSearch />} />
        <Route
          path={`${ROUTES.MEMBER_CONTRIBUTION_VIEW}/:memberId`}
          element={<MemberContributionView />}
        />
        <Route
          path={`${ROUTES.MEMBER_VIEW}/:memberId`}
          element={<MemberDetails />}
        />
        <Route
          path={`${ROUTES.MEMBER_CONTRIBUTION_VIEW_UPDATE}/:memberId`}
          element={<MemberContributionViewUpdate />}
        />
        <Route
          path={`${ROUTES.MEMBER_CONTRIBUTION_DETAILS}/:memberId`}
          element={<ContributionDetails />}
        />
        <Route
          path={`${ROUTES.MEMBER_CONTRIBUTION_UPDATE}/:memberId/:paymentOrderId`}
          element={<MemberContributionUpdate />}
        />
        <Route
          exact
          path={ROUTES.PENDING_ONLINE_CONTRIBUTION}
          element={<PendingOnlineContribution />}
        />
        <Route
          exact
          path={ROUTES.CAPTURE_ONLINE_CONTRIBUTION}
          // element={<CaptureOnlineContribution />}
          element={<NewCaptureOnlineContribution />}
        />
        <Route
          exact
          path={ROUTES.REPORT_CAPTURE_ONLINE_CONTRIBUTION}
          element={<CaptureOnlineContributionReport />}
        />
        <Route
          exact
          path={ROUTES.SEARCH_ONLINE_CONTRIBUTION_PRINT_FORM}
          element={<SearchOnlineContributionPrintForm />}
        />
        <Route
          exact
          path={ROUTES.FORM_10_BE_SEARCH}
          element={<Form10BESearch />}
        />
        <Route exact path={ROUTES.CASH_REPORT} element={<CashReport />} />
        <Route
          exact
          path={ROUTES.BULK_RECEIPT_DOWNLOAD}
          element={<BulkReceiptDownload />}
        />
      </Route>
    </Routes>
  );
}

export default AppRouter;
